import { Client, CrmLead } from '../services/crmService';
import { User } from '../services/authService';

export const EMAIL_TEMPLATE_MERGE_FIELDS = [
  '{{first_name}}',
  '{{last_name}}',
  '{{full_name}}',
  '{{company_name}}',
  '{{business_name}}',
  '{{sender_name}}',
] as const;

export const OUTREACH_TEMPLATE_VARIABLES = [
  '{{first_name}}',
  '{{last_name}}',
  '{{company_name}}',
  '{{email}}',
  '{{phone}}',
  '{{city}}',
  '{{state}}',
  '{{industry}}',
] as const;

/** Mirrors backend outbound_email.services.template_render for preview. */
export function applyEmailTemplateVars(
  text: string,
  contact: Client | CrmLead,
  user: User | null
): string {
  let full = (contact.full_name || '').trim();
  let first = '';
  let last = '';

  if ('first_name' in contact && ((contact as CrmLead).first_name || (contact as CrmLead).last_name)) {
    const l = contact as CrmLead;
    first = (l.first_name || '').trim();
    last = (l.last_name || '').trim();
    if (!full) full = `${first} ${last}`.trim();
  } else {
    const parts = full.split(/\s+/);
    first = parts[0] || '';
    last = parts.length > 1 ? parts.slice(1).join(' ') : '';
  }
  const sender =
    user && (user.first_name || user.last_name)
      ? `${user.first_name || ''} ${user.last_name || ''}`.trim()
      : user?.email || '';
  const business = user?.tenant?.name || '';

  const company_name =
    'company_name' in contact && (contact as Client).company_name !== undefined
      ? (contact as Client).company_name || ''
      : (contact as CrmLead).company || '';

  const mapping: Record<string, string> = {
    first_name: first,
    last_name: last,
    full_name: full,
    company_name,
    business_name: business,
    sender_name: sender,
  };

  const replaceVar = (_raw: string, key: string) =>
    Object.prototype.hasOwnProperty.call(mapping, key) ? mapping[key] : '';

  return text
    .replace(/\{\{\s*([a-z_]+)\s*\}\}/g, replaceVar)
    .replace(/\{([a-z_]+)\}/g, replaceVar);
}
